import { RootState } from '@store/rootReducer'

export const selectAIFilters = (state: RootState) => state.editor.aiFilterReducer.aiFilters
export const selectStyleFromCreatePage = (state: RootState) => state.editor.aiFilterReducer.styleFromCreatePage
export const selectPendingMagicTemplatesCategoryId = (state: RootState) =>
  state.editor.aiFilterReducer.pendingMagicTemplatesCategoryId
